import usePageOfTaskRoleAssignments from './usePageOfTaskRoleAssignments';
import usePageOfTaskResourceRoleAssignments from './usePageOfTaskResourceRoleAssignments';

const useAssignedRolesQuery = ({
  variant,
  taskUri,
  userUri,
  page,
  pageSize,
  textSearch,
  skipAssignedRolesQuery = false
}) => {
  const isTask = variant === 'taskRole';

  const taskResult = usePageOfTaskRoleAssignments({
    taskUri,
    page,
    pageSize,
    textSearch,
    skip: skipAssignedRolesQuery || !isTask
  });

  const resourceResult = usePageOfTaskResourceRoleAssignments({
    taskUri,
    userUri,
    page,
    pageSize,
    textSearch,
    skip: skipAssignedRolesQuery || isTask
  });

  return isTask ? taskResult : resourceResult;
};

export default useAssignedRolesQuery;
